import {
  LayoutDashboard,
  CalendarDays,
  Users,
  UserCog,
  UsersRound,
  School,
  Car,
  Wrench,
  FileText,
  CreditCard,
  BarChart3,
  Briefcase,
  Bell,
  Clock,
  Receipt,
  Settings,
  Megaphone,
} from "lucide-react";

export const NAV_CONFIG = {
  admin: [
    { label: "Dashboard", path: "/", icon: LayoutDashboard },
    { label: "Schedule", path: "/schedule", icon: CalendarDays },
    { label: "Students", path: "/students", icon: Users },
    { label: "Instructors", path: "/instructors", icon: UserCog },
    { label: "Parents", path: "/parents", icon: UsersRound },
    { label: "Classrooms", path: "/classrooms", icon: School },
    { label: "Fleet", path: "/vehicles", icon: Car },
    { label: "Vehicle Issues", path: "/vehicle-issues", icon: Wrench },
    { label: "Forms", path: "/forms", icon: FileText },
    { label: "Payments", path: "/payments", icon: CreditCard },
    { label: "Expenses", path: "/expenses", icon: Receipt },
    { label: "Reports", path: "/reports", icon: BarChart3 },
    { label: "Staff & Instructors", path: "/staff", icon: Briefcase, adminOnly: true },
    { label: "Announcements", path: "/communication-center", icon: Megaphone },
    { label: "Notifications", path: "/notifications", icon: Bell },
    { label: "Settings", path: "/settings", icon: Settings, adminOnly: true },
  ],
  office_staff: [
    { label: "Dashboard", path: "/", icon: LayoutDashboard },
    { label: "Schedule", path: "/schedule", icon: CalendarDays },
    { label: "Students", path: "/students", icon: Users },
    { label: "Instructors", path: "/instructors", icon: UserCog },
    { label: "Parents", path: "/parents", icon: UsersRound },
    { label: "Classrooms", path: "/classrooms", icon: School },
    { label: "Fleet", path: "/vehicles", icon: Car },
    { label: "Vehicle Issues", path: "/vehicle-issues", icon: Wrench },
    { label: "Forms", path: "/forms", icon: FileText },
    { label: "Payments", path: "/payments", icon: CreditCard },
    { label: "Expenses", path: "/expenses", icon: Receipt },
    { label: "Reports", path: "/reports", icon: BarChart3 },
    { label: "Announcements", path: "/communication-center", icon: Megaphone },
    { label: "Notifications", path: "/notifications", icon: Bell },
  ],
  instructor: [
    { label: "Dashboard", path: "/", icon: LayoutDashboard },
    { label: "Schedule", path: "/schedule", icon: CalendarDays },
    { label: "My Students", path: "/students", icon: Users },
    { label: "Time Clock", path: "/time-tracking", icon: Clock },
    { label: "Vehicle Issues", path: "/vehicle-issues", icon: Wrench },
    { label: "Expenses", path: "/expenses", icon: Receipt },
    { label: "Notifications", path: "/notifications", icon: Bell },
  ],
  parent: [
    { label: "Dashboard", path: "/", icon: LayoutDashboard },
    { label: "Schedule", path: "/schedule", icon: CalendarDays },
    { label: "Classrooms", path: "/classrooms", icon: School },
    { label: "Forms", path: "/forms", icon: FileText },
    { label: "Payments", path: "/payments", icon: CreditCard },
    { label: "Notifications", path: "/notifications", icon: Bell },
  ],
};
